(function(){
  if (window.__lvHomeReady) return;
  window.__lvHomeReady = true;

  function initFade(root){
    if (root.getAttribute('data-lv-fade-ready') === 'true') return;
    root.setAttribute('data-lv-fade-ready', 'true');

    var viewport = root.querySelector('[data-lv-fade-viewport]') || root.querySelector('.lv-fade__viewport');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-lv-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-lv-dot]'));
    if (!viewport || slides.length < 2) return;

    var current = 0;
    var delay = parseInt(root.getAttribute('data-delay') || '4000', 10);
    var dragEnabled = root.getAttribute('data-drag-enabled') !== 'false';
    var timer = null;
    var pointerDown = false;
    var pointerId = null;
    var startX = 0;
    var deltaX = 0;
    var dragWidth = 0;
    var targetIndex = 0;
    var targetSlide = null;
    var dragged = false;
    var suppressClick = false;

    function clearSlideStyles(slide){
      slide.style.removeProperty('transition');
      slide.style.removeProperty('transform');
      slide.style.removeProperty('opacity');
      slide.style.removeProperty('z-index');
      slide.style.removeProperty('pointer-events');
    }

    function clearDragStyles(){
      slides.forEach(clearSlideStyles);
      root.classList.remove('is-dragging', 'is-settling');
      targetSlide = null;
    }

    function show(index){
      current = (index + slides.length) % slides.length;
      slides.forEach(function(slide, i){
        slide.classList.toggle('is-active', i === current);
      });
      dots.forEach(function(dot, i){
        dot.classList.toggle('is-active', i === current);
      });
    }

    function stop(){
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start(){
      stop();
      timer = setInterval(function(){ show(current + 1); }, delay);
    }

    function resumeAutoplay(pointerType){
      if (pointerType === 'mouse' && root.matches(':hover')) return;
      start();
    }

    dots.forEach(function(dot, i){
      dot.addEventListener('click', function(){
        clearDragStyles();
        show(i);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', function(){
      if (!pointerDown) start();
    });

    root.addEventListener('dragstart', function(event){
      event.preventDefault();
    });

    root.addEventListener('click', function(event){
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    if (dragEnabled) {
      viewport.addEventListener('pointerdown', function(event){
        if (event.target.closest('.lv-fade__dots')) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        pointerDown = true;
        pointerId = event.pointerId;
        startX = event.clientX;
        deltaX = 0;
        dragWidth = viewport.getBoundingClientRect().width || 1;
        dragged = false;
        targetSlide = null;
        stop();
        root.classList.add('is-dragging');

        if (viewport.setPointerCapture) {
          try { viewport.setPointerCapture(pointerId); } catch (error) {}
        }
      });

      viewport.addEventListener('pointermove', function(event){
        if (!pointerDown || event.pointerId !== pointerId) return;

        deltaX = event.clientX - startX;
        if (Math.abs(deltaX) < 3) return;

        dragged = true;
        event.preventDefault();

        var direction = deltaX < 0 ? 1 : -1;
        var nextIndex = (current + direction + slides.length) % slides.length;
        var nextSlide = slides[nextIndex];

        if (targetSlide && targetSlide !== nextSlide) clearSlideStyles(targetSlide);
        targetIndex = nextIndex;
        targetSlide = nextSlide;

        var activeSlide = slides[current];
        var targetOffset = direction > 0 ? dragWidth : -dragWidth;

        activeSlide.style.transition = 'none';
        activeSlide.style.opacity = '1';
        activeSlide.style.zIndex = '2';
        activeSlide.style.pointerEvents = 'none';
        activeSlide.style.transform = 'translate3d(' + deltaX + 'px,0,0)';

        targetSlide.style.transition = 'none';
        targetSlide.style.opacity = '1';
        targetSlide.style.zIndex = '1';
        targetSlide.style.pointerEvents = 'none';
        targetSlide.style.transform = 'translate3d(' + (deltaX + targetOffset) + 'px,0,0)';
      }, { passive: false });

      function finishDrag(event, cancelled){
        if (!pointerDown || (event.pointerId !== undefined && event.pointerId !== pointerId)) return;

        pointerDown = false;
        if (viewport.releasePointerCapture && pointerId !== null) {
          try { viewport.releasePointerCapture(pointerId); } catch (error) {}
        }

        var pointerType = event.pointerType || 'mouse';
        pointerId = null;

        if (!dragged || !targetSlide) {
          clearDragStyles();
          resumeAutoplay(pointerType);
          return;
        }

        suppressClick = true;
        setTimeout(function(){ suppressClick = false; }, 50);

        var activeSlide = slides[current];
        var direction = deltaX < 0 ? 1 : -1;
        var targetOffset = direction > 0 ? dragWidth : -dragWidth;
        var threshold = Math.min(130, Math.max(50, dragWidth * 0.1));
        var commit = !cancelled && Math.abs(deltaX) >= threshold;

        root.classList.remove('is-dragging');
        root.classList.add('is-settling');
        activeSlide.style.transition = 'transform .34s cubic-bezier(.22,.61,.36,1), opacity .34s ease';
        targetSlide.style.transition = 'transform .34s cubic-bezier(.22,.61,.36,1), opacity .34s ease';

        if (commit) {
          activeSlide.style.transform = 'translate3d(' + (-targetOffset) + 'px,0,0)';
          activeSlide.style.opacity = '0.9';
          targetSlide.style.transform = 'translate3d(0,0,0)';
          targetSlide.style.opacity = '1';

          window.setTimeout(function(){
            show(targetIndex);
            clearDragStyles();
            resumeAutoplay(pointerType);
          }, 350);
        } else {
          activeSlide.style.transform = 'translate3d(0,0,0)';
          activeSlide.style.opacity = '1';
          targetSlide.style.transform = 'translate3d(' + targetOffset + 'px,0,0)';

          window.setTimeout(function(){
            show(current);
            clearDragStyles();
            resumeAutoplay(pointerType);
          }, 350);
        }
      }

      viewport.addEventListener('pointerup', function(event){ finishDrag(event, false); });
      viewport.addEventListener('pointercancel', function(event){ finishDrag(event, true); });
    }

    show(0);
    start();
  }

  function initProductSlider(root){
    if (root.getAttribute('data-lv-product-slider-ready') === 'true') return;
    root.setAttribute('data-lv-product-slider-ready', 'true');

    var track = root.querySelector('[data-lv-product-track]');
    if (!track || track.children.length < 2) return;
    var timer;
    var delay = parseInt(root.getAttribute('data-delay') || '3000', 10);
    function step(){
      var first = track.children[0];
      if (!first) return;
      var gap = parseFloat(getComputedStyle(track).gap || '0');
      var amount = first.getBoundingClientRect().width + gap;
      var max = track.scrollWidth - track.clientWidth - 4;
      if (track.scrollLeft >= max) track.scrollTo({left:0, behavior:'smooth'});
      else track.scrollBy({left:amount, behavior:'smooth'});
    }
    function start(){ stop(); timer = setInterval(step, delay); }
    function stop(){ if(timer) clearInterval(timer); }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('touchstart', stop, {passive:true});
    root.addEventListener('touchend', start, {passive:true});
    start();
  }

  function initBranches(root){
    if (root.getAttribute('data-lv-branches-ready') === 'true') return;
    root.setAttribute('data-lv-branches-ready', 'true');

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-lv-branch-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-lv-branch-panel]'));
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        var id = tab.getAttribute('data-lv-branch-tab');
        tabs.forEach(function(item){ item.classList.toggle('is-active', item === tab); });
        panels.forEach(function(panel){ panel.classList.toggle('is-active', panel.getAttribute('data-lv-branch-panel') === id); });
      });
    });
  }

  function init(scope){
    (scope || document).querySelectorAll('[data-lv-fade]').forEach(initFade);
    (scope || document).querySelectorAll('[data-lv-product-slider]').forEach(initProductSlider);
    (scope || document).querySelectorAll('[data-lv-branches]').forEach(initBranches);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function(event){ init(event.target); });
})();
